var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.729,
    height: 636.017,
    viewBox: "0 0 800.729 636.017",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-645.964 -128.091)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.061,
    cy: 8.318,
    rx: 109.061,
    ry: 8.318,
    transform: "translate(645.964 747.472)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.651,140.214c6.164-6.273,14.4-8.177,18.388-4.254s2.229,12.187-3.937,18.461a22.009,22.009,0,0,1-8.755,5.6L154.9,186.273,142.843,173.6l27.357-24.53a22.01,22.01,0,0,1,5.452-8.853Z",
    transform: "translate(667.91 218.718)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.142,126.48l27.734,61.527,44.287-23.973,15.85,8.412s-36.2,60.526-60.993,53.636-68.807-69.365-60.876-88.647,34-10.956,34-10.956Z",
    transform: "translate(627.822 210.786)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.454,382.225l20.223,0,9.62-78-29.847,0Z",
    transform: "translate(638.349 365.091)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,356.469h0c.63,1.06.962,4.483.962,5.716h0A6.864,6.864,0,0,1,174,369.049H111.371a4.682,4.682,0,0,1-4.682-4.682v-2.607s-3.1-7.837,3.28-17.5c0,0,7.928,7.563,19.773-4.283l3.493-6.328,25.286,18.493,14.016,1.725c3.066.377,5.785-.059,7.362,2.6h0Z",
    transform: "translate(636.189 390.388)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.721,145.23l.409-27.276-16.82-10.485L98.02,129.842Z",
    transform: "translate(629.385 195.984)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.914,
    cy: 29.914,
    r: 29.914,
    transform: "translate(732.245 262.598)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.152,245.687,144.286,435.312H109.324l4.649-108.243,2.447-56.915-7.1-27.091a121,121,0,0,1-5.961-13.321c-3.072-8.237-5.5-18.113-1.9-22.8,1.325-1.726,4.771-3,9.454-3.956a97.846,97.846,0,0,1,9.787-1.393c20.675-2.046,50.084-.768,50.084-.768l.748,24.672.415,13.777Z",
    transform: "translate(630.803 275.888)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3,376.853l20.008,2.94,20.864-75.774-29.53-4.339Z",
    transform: "translate(621.886 361.189)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.229,359.929h0c.469,1.141.3,4.575.12,5.8h0a6.864,6.864,0,0,1-7.789,5.792L90.6,362.407a4.682,4.682,0,0,1-3.952-5.314l.379-2.58s-1.925-8.2,5.79-16.832c0,0,6.743,8.636,20.186-1.361l4.377-5.753,22.327,21.974,13.616,3.746c2.979.819,5.732.784,6.906,3.641h0Z",
    transform: "translate(619.567 387.737)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.133,216.238l-3.822,32.916-20.844,69.363L123.154,432.711l-34.586-5.083,31.041-162.368-3.073-27.842s-1-2.767-2.148-6.819c-2.277-8.016-5.134-21.069-1.991-27.727a7.783,7.783,0,0,1,1.616-2.326c1.236-1.2,3.748-1.927,7.114-2.313,14.068-1.59,43.04,2.958,55.931,5.19l5.076,12.814Z",
    transform: "translate(621.261 273.712)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.141,116.4l33.983,16.312s36.022,106.707,36.022,112.144,10.195,8.836,4.078,14.953,11.385,11.3,1.955,16.183-68.262,31.612-74.8,29.2c-18.042-6.647.765-31.072.765-31.072S98.587,263.2,100.626,257.767,88.392,148.342,88.392,148.342L110.141,116.4Z",
    transform: "translate(621.11 203.657)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.008,124.631l3.848,7.7s3.848-13.851,10-16.929,6.926-7.7,6.926-7.7,7.7,10,13.082,7.7,7.7-3.848,1.539-13.082-4.617-4.617-4.617-4.617-5.387-7.7-4.617-5.387-4.617-6.156-4.617-3.848-3.848-4.617-3.848-2.309-16.16-5.387-13.851-2.309S121,77.691,113.31,90s-18.365,10.035-14.569,17.715S101,136.174,101,136.174H111.61s10.934-20.777,19.4-11.543Z",
    transform: "translate(629.323 175.046)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.623,623.3H527.682a6.939,6.939,0,0,1-6.932-6.932V425.048a6.939,6.939,0,0,1,6.932-6.932H967.623a6.939,6.939,0,0,1,6.932,6.932V616.367a6.939,6.939,0,0,1-6.932,6.932ZM527.682,420.889a4.164,4.164,0,0,0-4.159,4.159V616.367a4.164,4.164,0,0,0,4.159,4.159H967.623a4.164,4.164,0,0,0,4.159-4.159V425.048a4.164,4.164,0,0,0-4.159-4.159Z",
    transform: "translate(472.138 -181.512)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.409,443.616a4.159,4.159,0,1,0,0,8.318h58.227a4.159,4.159,0,1,0,0-8.318Z",
    transform: "translate(470.434 -183.444)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.858,474.775V551.9H554.21V511.294c2.719-1.746,5.454-3.484,8.214-5.164,11.788-7.214,24.4-13.96,38.156-16.46a57.6,57.6,0,0,1,19.7-.246c6.9,1.139,13.5,3.517,20.043,5.9,6.448,2.361,12.913,4.8,19.657,6.164a57.554,57.554,0,0,0,19.936.393c12.625-1.894,24.487-6.968,36.3-11.558,11.886-4.615,24.134-8.976,37-9.55,12.7-.574,25.243,2.426,37.293,6.148,24.569,7.582,49.656,18.829,75.671,11.115,26.417-7.82,50.716-30.4,79.992-23.7a1.1,1.1,0,0,1,.69.434Z",
    transform: "translate(469.603 -185.678)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.835,476.12a1.185,1.185,0,0,1-1.344.59,43.777,43.777,0,0,0-10.64-1.1c-28.8.508-50.938,23.69-79.1,27.158-25.387,3.123-49.282-9.222-73.152-15.673-12.4-3.353-25.19-5.131-37.953-2.853-12.665,2.254-24.551,7.435-36.486,12.034-11.493,4.426-23.436,8.542-35.879,8.746-13.681.229-26-5.41-38.691-9.706-6.6-2.238-13.37-4.008-20.362-4.181a61.6,61.6,0,0,0-20.067,3.107c-13.484,4.287-25.633,11.927-37.461,19.518a1.051,1.051,0,0,1-.7.189,1.27,1.27,0,0,1-.541-2.312l.541-.344c2.713-1.746,5.443-3.484,8.2-5.164,11.763-7.214,24.354-13.96,38.076-16.46a57.361,57.361,0,0,1,19.657-.246c6.886,1.139,13.476,3.517,20,5.9,6.435,2.361,12.886,4.8,19.616,6.164a57.315,57.315,0,0,0,19.895.393c12.6-1.894,24.436-6.968,36.224-11.558,11.861-4.615,24.083-8.976,36.92-9.55,12.673-.574,25.19,2.426,37.215,6.148,24.518,7.582,49.552,18.829,75.513,11.115,26.362-7.82,50.61-30.4,79.825-23.7a1.1,1.1,0,0,1,.689.434A1.263,1.263,0,0,1,946.835,476.12Z",
    transform: "translate(469.627 -185.678)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.738,
    cy: 5.738,
    r: 5.738,
    transform: "translate(1072.177 299.007)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.738,
    cy: 5.738,
    r: 5.738,
    transform: "translate(1217.268 291.63)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.738,
    cy: 5.738,
    r: 5.738,
    transform: "translate(1376.931 297.537)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.909,593.616a4.159,4.159,0,1,0,0,8.318h58.227a4.159,4.159,0,1,0,0-8.318Z",
    transform: "translate(465.775 -194.807)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.712,
    cy: 15.712,
    r: 15.712,
    transform: "translate(1021.54 386.794)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.909,593.616a4.159,4.159,0,1,0,0,8.318h58.227a4.159,4.159,0,1,0,0-8.318Z",
    transform: "translate(454.26 -194.807)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.712,
    cy: 15.712,
    r: 15.712,
    transform: "translate(1162.025 386.794)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.909,593.616a4.159,4.159,0,1,0,0,8.318h58.227a4.159,4.159,0,1,0,0-8.318Z",
    transform: "translate(442.746 -194.807)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.712,
    cy: 15.712,
    r: 15.712,
    transform: "translate(1302.511 386.794)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.251,357.465H736.2c-4.231,0-7.66-2.443-7.665-5.453V304.837c0-3.01,3.434-5.453,7.665-5.453H953.251c4.231,0,7.66,2.443,7.665,5.453v47.174C960.912,355.021,957.482,357.461,953.251,357.465ZM736.2,301.563c-2.539,0-4.6,1.466-4.6,3.272v47.174c0,1.806,2.06,3.27,4.6,3.272H953.251c2.539,0,4.6-1.466,4.6-3.272V304.837c0-1.806-2.06-3.27-4.6-3.272Z",
    transform: "translate(108.881 -171.292)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.55,328.391a4.627,4.627,0,0,0-4.621,4.621v32.349a4.627,4.627,0,0,0,4.621,4.621H954.99a4.627,4.627,0,0,0,4.621-4.621V333.012a4.627,4.627,0,0,0-4.621-4.621Z",
    transform: "translate(104.609 -173.49)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.167,
    cy: 10.167,
    r: 10.167,
    transform: "translate(907.099 165.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.72,346.616a4.159,4.159,0,0,0,0,8.318h58.227a4.159,4.159,0,0,0,0-8.318Z",
    transform: "translate(98.88 -174.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.251,238.465H560.2c-4.231,0-7.66-2.443-7.665-5.453V185.837c0-3.01,3.434-5.453,7.665-5.453H777.251c4.231,0,7.66,2.443,7.665,5.453v47.174C784.912,236.021,781.482,238.461,777.251,238.465ZM560.2,182.563c-2.539,0-4.6,1.466-4.6,3.272v47.174c0,1.806,2.06,3.27,4.6,3.272H777.251c2.539,0,4.6-1.466,4.6-3.272V185.837c0-1.806-2.06-3.27-4.6-3.272Z",
    transform: "translate(391.797 308.6)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.55,209.391a4.627,4.627,0,0,0-4.621,4.621v32.349a4.627,4.627,0,0,0,4.621,4.621H778.99a4.627,4.627,0,0,0,4.621-4.621V214.012a4.627,4.627,0,0,0-4.621-4.621Z",
    transform: "translate(387.526 306.403)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.167,
    cy: 10.167,
    r: 10.167,
    transform: "translate(1014.015 526.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.72,227.616a4.159,4.159,0,1,0,0,8.318h58.227a4.159,4.159,0,1,0,0-8.318Z",
    transform: "translate(381.796 305.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945.154 426.219) rotate(164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.634,1.512l37.034,47.445a3.942,3.942,0,0,1-.681,5.524c-8.6,20.882-34.33,36.367-64.6,50.422a3.94,3.94,0,0,1-5.524-.681L.832,56.777a3.94,3.94,0,0,1,.681-5.524C26.913,36.911,48.744,20.294,66.11.831a3.942,3.942,0,0,1,5.524.681Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.473,52.787,11.746,67.229A42.2,42.2,0,0,0,70.8,74.508L102.4,49.848a2.242,2.242,0,0,0,.39-3.143L67,.859A2.242,2.242,0,0,0,63.856.475C47.875,21.11,26.484,37.169.86,49.647A2.24,2.24,0,0,0,.473,52.787Z",
    transform: "translate(2.958 2.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.253,1.927l7.341,9.405A1.193,1.193,0,1,0,9.475,9.864L2.134.459A1.193,1.193,0,1,0,.253,1.927Z",
    transform: "translate(72.12 25.485)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.253,1.927,16.375,22.582a1.193,1.193,0,0,0,1.881-1.468L2.134.459A1.193,1.193,0,0,0,.253,1.927Z",
    transform: "translate(58.35 18.508)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.859,
    cy: 7.859,
    r: 7.859,
    transform: "translate(78.241 39.17)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.177,1.828,19.978,27.2a1.2,1.2,0,0,0,1.881-1.468L2.058.359A1.2,1.2,0,0,0,.177,1.828Z",
    transform: "translate(57.57 34.932)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.177,1.828,27.815,37.236A1.2,1.2,0,0,0,29.7,35.767L2.058.359A1.2,1.2,0,0,0,.177,1.828Z",
    transform: "translate(44.724 29.14)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.177,1.828,19.978,27.2a1.2,1.2,0,0,0,1.881-1.468L2.058.359A1.2,1.2,0,0,0,.177,1.828Z",
    transform: "translate(44.82 44.884)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.177,1.828,19.978,27.2a1.2,1.2,0,0,0,1.881-1.468L2.058.359A1.2,1.2,0,0,0,.177,1.828Z",
    transform: "translate(18.619 48.013)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.177,1.828,27.815,37.236A1.2,1.2,0,0,0,29.7,35.767L2.058.359A1.2,1.2,0,0,0,.177,1.828Z",
    transform: "translate(31.974 39.092)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(727.548 342.738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.524,167.424c8.434-2.492,16.556-.16,18.141,5.208s-3.967,11.737-12.4,14.229a22.009,22.009,0,0,1-10.374.649l-35.868,10.106-4.384-16.933,35.825-8.165a22.01,22.01,0,0,1,9.065-5.093Z",
    transform: "translate(-69.272 -96.081)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.908,139.929l-5.622,67.254,50.356.541,9.773,15.049s-61.035,35.34-79.362,17.283S90.573,146.009,106.867,133s35.041,6.927,35.041,6.927Z",
    transform: "translate(-98.097 -128.596)",
    fill: "#75c4c0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.bd6069820180975df451bfa040b2f143.svg";
export { ForwardRef as ReactComponent };